import { Button } from '@/components/atoms';
import { ArrowLeftIcon } from 'lucide-react';

export const Pagination = ({
  currentPage,
  lastPage,
  onPrev,
  onNext,
}: {
  currentPage: number;
  lastPage: number;
  onPrev: () => void;
  onNext: () => void;
}) => {
  const canPrev = currentPage > 1;
  const canNext = currentPage < lastPage;

  return (
    <div className="flex items-center justify-center gap-2">
      <Button variant="outline" size="sm" disabled={!canPrev} onClick={onPrev}>
        <ArrowLeftIcon className="w-4 h-4" />
      </Button>
      <Button size="sm" className="bg-green-600 text-white">
        {currentPage}
      </Button>
      <Button variant="outline" size="sm" disabled={!canNext} onClick={onNext}>
        <ArrowLeftIcon className="w-4 h-4 rotate-180" />
      </Button>
    </div>
  );
};
